import { useCallback, useEffect } from 'react';
import { useAppState } from '../context/zustand';

export function useEpisodeSelectionConsumer(consumerId) {
    const revision = useAppState((state) => state.episodeSelectionRevision);
    const register = useAppState((state) => state.registerEpisodeSelectionConsumer);
    const unregister = useAppState((state) => state.unregisterEpisodeSelectionConsumer);
    const acknowledge = useAppState((state) => state.acknowledgeEpisodeSelectionConsumer);

    useEffect(() => {
        register(consumerId);
        return () => unregister(consumerId);
    }, [consumerId, register, unregister]);

    const isCurrentRevision = useCallback((candidateRevision) => (
        useAppState.getState().episodeSelectionRevision === candidateRevision
    ), []);

    const acknowledgeAfterPaint = useCallback((candidateRevision) => {
        const finish = () => {
            if (isCurrentRevision(candidateRevision)) {
                acknowledge(candidateRevision, consumerId);
            }
        };

        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(finish);
            return;
        }

        Promise.resolve().then(finish);
    }, [acknowledge, consumerId, isCurrentRevision]);

    return { revision, isCurrentRevision, acknowledgeAfterPaint };
}
